import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "has-first-letter-uppercase has-text-success is-size-5" }
const _hoisted_2 = { class: "has-first-letter-uppercase is-size-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    ref: "modal",
    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onClose()))
  }, {
    header: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.title), 1 /* TEXT */)
    ]),
    body: _withCtx(() => [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.question), 1 /* TEXT */)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        class: "button is-light mr-2",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close(false)))
      }, _toDisplayString(_ctx.cancel), 1 /* TEXT */),
      _createElementVNode("button", {
        class: "button is-success",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
      }, _toDisplayString(_ctx.ok), 1 /* TEXT */)
    ]),
    _: 1 /* STABLE */
  }, 512 /* NEED_PATCH */))
}